import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { toast } from "react-toastify";
import axios from 'axios';
import moment from 'moment';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';

const NewDriverRegistrations = props => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNewRegistrations();
  }, []);

  const fetchNewRegistrations = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const response = await axios.get(
        `${process.env.REACT_APP_WEB_APP_URL}/api/web/new-driver-registrations`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success && response.data.data) {
        setData(response.data.data);
      } else {
        toast.error('Failed to fetch new registrations', {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error fetching new registrations:", error);
      toast.error('Failed to fetch new registrations', {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (driverId) => {
    navigate(`/new-driver-registrations/${driverId}`);
  };

  const columns = useMemo(
    () => [
      {
        header: 'Driver Name',
        accessorKey: 'driver_name',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Email',
        accessorKey: 'driver_email',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Phone',
        accessorKey: 'phone',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const phoneCode = row.original.phone_code || '';
          const phone = row.original.phone || '';
          return `${phoneCode} ${phone}`;
        }
      },
      {
        header: 'Pending Driver Docs',
        accessorKey: 'pending_driver_documents_count',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const count = row.original.pending_driver_documents_count || 0;
          return (
            <span className="badge bg-warning">{count}</span>
          );
        }
      },
      {
        header: 'Pending Vehicle Docs',
        accessorKey: 'pending_vehicle_documents_count',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const count = row.original.pending_vehicle_documents_count || 0;
          return (
            <span className="badge bg-warning">{count}</span>
          );
        }
      },
      {
        header: 'Registration Date',
        accessorKey: 'created_at',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          return moment(row.original.created_at).format('YYYY-MM-DD HH:mm');
        }
      },
      {
        header: 'Action',
        id: 'action',
        cell: ({ row }) => {
          return (
            <button
              className="btn btn-sm btn-primary"
              onClick={() => handleViewDetails(row.original.driver_id)}
            >
              <i className="mdi mdi-eye"></i> View Details
            </button>
          );
        }
      }
    ],
    []
  );

  document.title = "New Driver Registrations | Moeen";
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="New Driver Registrations" />
        {loading ? (
          <Skeleton count={10} height={40} />
        ) : (
          <TableContainer
            columns={columns}
            data={data || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder={`Looking for something? ${data.length} results loaded.`}
            pagination="pagination"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
          />
        )}
      </div>
    </div>
  );
};

NewDriverRegistrations.propTypes = {
  t: PropTypes.any
};

export default NewDriverRegistrations;



